// Local leaderboard, persisted through the StorageManager. Acts as the always-on
// board plus an offline cache for remote boards. Entries the player submits on
// this device are flagged so top() can mark them isMe.

export class LocalLeaderboard {
  constructor(storage, maxEntries = 50) {
    this.storage = storage;
    this.maxEntries = maxEntries;
  }

  _key(boardId) { return `lb:${boardId}`; }

  async submit(boardId, { name, score, meta } = {}) {
    const entries = (await this.storage.load(this._key(boardId), [])) || [];
    const entry = {
      name: String(name || 'Player').slice(0, 32),
      score: Number(score) || 0,
      meta: meta ?? null,
      at: Date.now(),
      mine: true,
    };
    entries.push(entry);
    entries.sort((a, b) => b.score - a.score || a.at - b.at);
    const trimmed = entries.slice(0, this.maxEntries);
    await this.storage.save(this._key(boardId), trimmed);
    const rank = trimmed.indexOf(entry) + 1;
    return { ok: true, rank: rank || null };
  }

  async top(boardId, limit = 10) {
    const entries = (await this.storage.load(this._key(boardId), [])) || [];
    return entries.slice(0, limit).map((e, i) => ({
      rank: i + 1,
      name: e.name,
      score: e.score,
      meta: e.meta ?? null,
      isMe: !!e.mine,
    }));
  }
}
